// api/api.js
import axios from 'axios';
const backendURL = process.env.REACT_APP_API_URL

const instance = axios.create({
  baseURL: backendURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add authorization header
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;